import { useTranslations } from 'next-intl';
import React from 'react';

import { ButtonStyle } from '@cineamo/ui/src/button/ButtonStyle.enum';
import Button from '@cineamo/ui/src/button/NewButton';
import Modal, { ModalProps } from '@cineamo/ui/src/modals/Modal';

const PageLeaveWarningModal: React.FC<
    ModalProps & {
        handleConfirm: () => void;
        handleCancel: () => void;
    }
> = ({ handleConfirm, handleCancel, ...props }) => {
    const t = useTranslations();
    return (
        <Modal
            title={t('tickets.page-leave-warning')}
            className="max-w-[480px]"
            {...props}>
            <div className="flex flex-col space-y-16 lg:flex-row lg:space-x-16 lg:space-y-0 lg:justify-end">
                <Button
                    className="min-h-[48px]"
                    style={ButtonStyle.delete_action}
                    onClick={handleConfirm}>
                    {t('common.yes')}
                </Button>
                <Button
                    className="min-h-[48px]"
                    style={ButtonStyle.outlined_on_surface}
                    onClick={handleCancel}>
                    {t('common.no')}
                </Button>
            </div>
        </Modal>
    );
};

export default PageLeaveWarningModal;
